import { IdentifierString } from '@iota/wallet-standard';

import {
  getExtendedErrorText,
  mainApi,
  queryFnNotifyWrapper,
} from 'modules/api';
import { authCacheTags } from 'modules/auth/authCacheTags';
import { withProvider } from 'modules/auth/utils/withProvider';

export const {
  useGetChainIdQuery,
  endpoints: { getChainId },
} = mainApi.injectEndpoints({
  endpoints: build => {
    return {
      getChainId: build.query<void, void>({
        queryFn: queryFnNotifyWrapper<void, never, IdentifierString>(
          async args =>
            withProvider({
              args,
              call: ({ provider }) => {
                return { data: provider.getCurrentChainId() };
              },
            }),
          error => getExtendedErrorText(error, 'Failed to get chain id'),
        ),
        providesTags: [authCacheTags.account],
      }),
    };
  },
});
